function NotFound() {
    return (
        <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
            <h1>404: Page Not Found</h1>
        </div>
    )
}

export default NotFound
